import React from 'react'
import { Link } from "react-router-dom"
import { Row, Col, Typography, Button, Space } from 'antd'

import Variations_img from '../../images/variations/Variations.svg'
import Haplotype from '../../images/variations/Haplotype.svg'
import SNP from '../../images/variations/SNP.svg'
import InDel from '../../images/variations/InDel.svg'
import SV from '../../images/variations/SV.svg'

import './variations.css'

const { Title } = Typography

class Variations extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col>
                        <img src={Variations_img} className="variations-bg" />
                        <div className="variations-bg-desc">
                            <Title level={2}>Variations</Title>
                            <Title level={5}>Collection of variations within tomato association mapping panel, including single nucleotide polymorphisms (SNPs), insertion and deletions (InDels) and structure variations (SVs).</Title>
                        </div>
                    </Col>
                </Row>
                <Row className="variations-feature" justify="center">
                    <Col span={6}>
                        <Row justify="center" align="middle">
                            <Col>
                                <Space>
                                    <Col>
                                        <img src={SNP} />
                                    </Col>
                                    <Col>
                                        <Title level={3}>SNP</Title>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                        <Row justify="center">
                            <Col span={24}>
                                <Link to="/search/snp_indel" className="search-a"><Button type="primary" size="large" className="search-btn">Search</Button></Link>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <a href="/tomato/tool/jbrowse/?loc=1%3A46684961..46686868&tracks=DNA%2CGene%20annotation%2Cindel%2Csnp%20&highlight=" className="search-a"><Button type="primary" size="large" className="jbrowse-btn">Jbrowse</Button></a>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={6}>
                        <Row justify="center" align="middle">
                            <Col>
                                <Space>
                                    <Col>
                                        <img src={InDel} />
                                    </Col>
                                    <Col>
                                        <Title level={3}>InDel</Title>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                        <Row justify="center">
                            <Col span={24}>
                                <Link to="/search/snp_indel" className="search-a"><Button type="primary" size="large" className="search-btn">Search</Button></Link>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <a href="/tomato/tool/jbrowse/?loc=1%3A46684961..46686868&tracks=DNA%2CGene%20annotation%2Cindel%2Cindel%20&highlight=" className="search-a"><Button type="primary" size="large" className="jbrowse-btn">Jbrowse</Button></a>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={6}>
                        <Row justify="center" align="middle">
                            <Col>
                                <Space>
                                    <Col>
                                        <img src={SV} />
                                    </Col>
                                    <Col>
                                        <Title level={3}>SV</Title>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                        <Row justify="center">
                            <Col span={24}>
                                <Link to="/search/sv" className="search-a"><Button type="primary" size="large" className="search-btn">Search</Button></Link>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <a href="/tomato/tool/jbrowse/?loc=1%3A48138001..48362400&tracks=DNA%2CGene%20annotation%2Csv&highlight=" className="search-a"><Button type="primary" size="large" className="jbrowse-btn">Jbrowse</Button></a>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default Variations
